import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: '100%',
  },
  formLabel: {
    fontSize: 14,
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  switchLabel: {
    '& .MuiFormControlLabel-label': {
      fontSize: 14,
      color: theme.palette.text.secondary,
    },
  },
  alert: {
    marginTop: theme.spacing(2),
  },
}))

export default useStyles
